import axiosConn from '../axiosConn';

/**
 * Fetches the unread notifications count for the current user.
 * @param {string} token - The user's auth token.
 * @returns {Promise<number>} The unread notifications count (or 0 on error).
 */
const getUnreadNotifications = async (token) => {
  try {
    const res = await axiosConn.get('notifications/my', {
      headers: { Authorization: `Bearer ${token}` },
    });
    // console.log('[getUnreadNotifications] response:', res.data.total);
    return res.data.total || 0;
  } catch {
    return 0;
  }
};

export default getUnreadNotifications;
